import { Flex, Button, Spacer, Center, Image, Text, Divider, Box, Link } from '@chakra-ui/react';
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment-timezone';

// Icons
import { IconEquipo, IconHogar, IconMovil, IconOferta } from '../../Assets/GENERALES/Icons';
import { FiPhoneCall } from "react-icons/fi";

// Componentes
import enviroments from '../../Services/enviroments';
import SlideModal from '../Slide/SlideModal';
import Footer from '../Footer/Footer';

// Images
import Logo from '../../Assets/Logos/entel-logo.webp';
import Whatsapp from '../../Assets/GENERALES/whatsapp.webp';

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import FormularioDown from '../Formulario/FormularioDown';

const Navbar = ({ children }) => {

    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [viewButtonWp, setViewButtonWp] = useState(false);
    const [urlWp, setUrlWp] = useState('');
    const [idWp, setIdWp] = useState('');
    const [id, setId] = useState('');

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    const location = useLocation();
    const navigate = useNavigate();

    let campaignid = urlParams.get('campaignid');
    let adgroupid = urlParams.get('adgroupid');
    let anuncioGroup = urlParams.get('group');
    let keyword = urlParams.get('keyword');
    let gclid = urlParams.get('gclid');
    let origen = urlParams.get('origin');
    let adId = urlParams.get('adId');
    let type = urlParams.get('type');

    const differenceInHours = moment.tz('America/Santiago').utcOffset() / 60 - moment.tz('America/Bogota').utcOffset() / 60;
    const horarioInicio = moment('09:00 AM', 'hh:mm A').subtract(differenceInHours, 'hours');
    const horarioFin = moment('08:00 PM', 'hh:mm A').subtract(differenceInHours, 'hours');

    useEffect(() => {
        if (location.pathname.includes(`${enviroments.urlBase}/planes-moviles`) || location.pathname === `${enviroments.urlBase}/`) { setIdWp('button_whatsapp_movil'); setId('Fibra Formulario Header Movil'); setUrlWp('https://api.whatsapp.com/send/?phone=56975630928&text=hola,+necesito+un+pl@n+movil+*&type=phone_number&app_absent=0'); };
        if (location.pathname.includes(`${enviroments.urlBase}/internet-hogar`)) { setIdWp('button_whatsapp_hogar'); setId('Fibra Formulario Header Hogar'); setUrlWp('https://api.whatsapp.com/send/?phone=56975630928&text=hola,+vi+esta+oferta+de+internet+Hogar+%F0%9F%91%86%F0%9F%8F%BB&type=phone_number&app_absent=0'); };
        if (location.pathname.includes(`${enviroments.urlBase}/ofertas`)) { setIdWp('button_whatsapp_ofertas'); setId('Formulario Header Ofertas'); setUrlWp('https://api.whatsapp.com/send/?phone=56975630928&text=Quiero+ayuda+para+comprar_&type=phone_number&app_absent=0'); };
        if (location.pathname.includes(`${enviroments.urlBase}/equipos`)) { setIdWp('button_whatsapp_equipos'); setId('Formulario Header Equipos'); setUrlWp('https://api.whatsapp.com/send/?phone=56975630928&text=hola,+quiero+un+equipo+%F0%9F%93%B1&type=phone_number&app_absent=0'); };
        
        // if (location.pathname.includes(`${enviroments.urlBase}/planes-moviles`) || location.pathname === `${enviroments.urlBase}/` || location.pathname.includes(`${enviroments.urlBase}/internet-hogar`)) {
        //     setViewButtonWp(false);
        // } else {
        //     setViewButtonWp(moment().isBetween(horarioInicio, horarioFin));
        // }
    }, [location])

    const activeRoute = (routeName) => {
        if (routeName?.includes('internet-hogar')) {
            return location.pathname.includes(routeName) ? "active" : "";
        } else {
            return location.pathname === routeName ? "active" : "";
        }
    };

    const openSlide = () => {
        window.dataLayer.push({
            'event': 'GARDevent',
            'eventCategory': 'entel ofertas - boton',
            'eventAction': 'click to action',
            'eventLabel': 'llamame ahora',
            'origen': 'entel',
            'segmento': 'otros',
            'mercado': 'pe',
            'variant': 'formulario header'
        });
        setOpenSlideModal(!openSlideModal);
    };

    const clickActionWp = (e) => {
        e.stopPropagation();
        let segmento = '';
        let mercado = '';

        if (location.pathname.includes(`${enviroments.urlBase}/planes-moviles`) || location.pathname === `${enviroments.urlBase}/`) {
            segmento = 'po';
            mercado = 'movil';
        } else if (location.pathname.includes(`${enviroments.urlBase}/internet-hogar`)) {
            segmento = 'hh';
            mercado = 'hogar';
        } else if (location.pathname.includes(`${enviroments.urlBase}/ofertas`)) {
            segmento = 'tm-equ';
            mercado = 'ofertas';
        } else if (location.pathname.includes(`${enviroments.urlBase}/equipos`)) {
            segmento = 'tm-equ';
            mercado = 'equipos';
        }

        window.dataLayer.push({
            event: "GARDevent",
            eventCategory: "entel ofertas - wtsp ",
            eventAction: "go to",
            eventLabel: "entel ventas",
            variant: `wtsp ${mercado}`,
            segmento: segmento,
            mercado: "pe"
        });
    }

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={enviroments?.site_key}
            useEnterprise={true}
        >
            {/* Navbar */}
            <Flex
                px={{ base: 3, md: 10 }}
                py={2}
                w="100%"
            >
                <Image src={Logo} onClick={() => navigate(`${enviroments.urlBase}/planes-moviles${origen ? `?origin=${origen}` : ''}${gclid ? `?gclid=${gclid}` : ''}${type ? `&type=${type}`: ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)} cursor='pointer' style={{width: '40px'}} alt="logo entel" h='auto' />
                <Spacer />
                <Center>
                    <Button borderRadius={'30px'} bg="#002EFF" onClick={() => openSlide()} size={{ base: 'sm', md: 'md' }} leftIcon={<FiPhoneCall />} textDecoration='none !important' color="white" _hover={{ border: '1px solid #002EFF', color: '#002EFF', bg: 'white' }} className="General gtm_btn_cta" data-mercado='pe' data-segmento='po' id='Click-to-call-desktop'>
                        <Text letterSpacing={'1px'}>
                            Contratar ahora
                        </Text>
                    </Button>
                </Center>
            </Flex>

            {/* División */}
            <Divider h='2px' bg='gray.200' />

            {/* Menú */}
            <Box w={['100%', '100%', '90%', '90%', '90%']} mx='auto'>
                <Splide
                    hasTrack={false}
                    options={{
                        perPage: 4,
                        perMove: 1,
                        pagination: false,
                        autoplay: false,
                        arrows: false,
                        breakpoints: {
                            840: {
                                perPage: 3,
                            },
                            600: {
                                perPage: 3,
                            }
                        },
                    }}
                >
                    <SplideTrack>
                        <SplideSlide>
                            <Button 
                                w='100%'
                                variant='link'
                                pt={3} borderRadius='0px'
                                onClick={() => navigate(`${enviroments.urlBase}/planes-moviles${origen ? `?origin=${origen}`: ''}${gclid ? `?gclid=${gclid}` : ''}${campaignid ? `&campaignid=${campaignid}` : ''}${type ? `&type=${type}`: ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)} 
                                flexDirection='column'
                                _hover={{}}
                                justifyContent='center'
                                alignItems='center'
                                borderBottom={activeRoute(`${enviroments.urlBase}/planes-moviles`) === 'active' ? '2px solid #002FFD' : activeRoute(`${enviroments.urlBase}/`) === 'active' ? '2px solid #002FFD' : '1px solid #A4A4A6'}
                            >
                                <IconMovil size='24px' color={activeRoute(`${enviroments.urlBase}/planes-moviles`) === 'active' ? '#002FFD' : activeRoute(`${enviroments.urlBase}/`) === 'active' ? '#002FFD' : 'black'} />
                                <Text color={activeRoute(`${enviroments.urlBase}/planes-moviles`) === 'active' ? '#002FFD' : activeRoute(`${enviroments.urlBase}/`) === 'active' ? '#002FFD' : 'black'} my='2' size='lg' className='General'>Planes móviles</Text>
                            </Button>
                        </SplideSlide>
                        <SplideSlide>
                            <Button 
                                w='100%' 
                                variant='link' 
                                pt={3} 
                                borderRadius='0px' 
                                onClick={() => navigate(`${enviroments.urlBase}/internet-hogar/internet${origen ? `?origin=${origen}`: ''}${gclid ? `?gclid=${gclid}` : ''}${type ? `&type=${type}`: ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)} 
                                flexDirection='column' 
                                _hover={{}} 
                                justifyContent='center' 
                                alignItems='center' 
                                borderBottom={activeRoute(`${enviroments.urlBase}/internet-hogar`) === 'active' ? '2px solid #002FFD' : '1px solid #A4A4A6'}
                            >
                                <IconHogar size='24px' color={activeRoute(`${enviroments.urlBase}/internet-hogar`) === 'active' ? '#002FFD' : 'black'} />
                                <Text color={activeRoute(`${enviroments.urlBase}/internet-hogar`) === 'active' ? '#002FFD' : 'black'} my='2' size='lg' className='General'>Internet Hogar</Text>
                            </Button>
                        </SplideSlide>
                        <SplideSlide>
                            <Button 
                                w='100%' 
                                variant='link' 
                                pt={3} 
                                borderRadius='0px' 
                                onClick={() => navigate(`${enviroments.urlBase}/equipos${origen ? `?origin=${origen}`: ''}${gclid ? `?gclid=${gclid}` : ''}${type ? `&type=${type}`: ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)} 
                                flexDirection='column' 
                                _hover={{}} 
                                justifyContent='center' 
                                alignItems='center' 
                                borderBottom={activeRoute(`${enviroments.urlBase}/equipos`) === 'active' ? '2px solid #002FFD' : '1px solid #A4A4A6'}
                            >
                                <IconEquipo size='24px' color={activeRoute(`${enviroments.urlBase}/equipos`) === 'active' ? '#002FFD' : 'black'} />
                                <Text color={activeRoute(`${enviroments.urlBase}/equipos`) === 'active' ? '#002FFD' : 'black'} my='2' size='lg' className='General'>Equipos</Text>
                            </Button>
                        </SplideSlide>
                        <SplideSlide>
                            <Button 
                                w='100%' 
                                variant='link' 
                                pt={3} 
                                borderRadius='0px' 
                                onClick={() => navigate(`${enviroments.urlBase}/ofertas${origen ? `?origin=${origen}`: ''}${gclid ? `?gclid=${gclid}` : ''}${type ? `&type=${type}`: ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)} 
                                flexDirection='column' 
                                _hover={{}} 
                                justifyContent='center' 
                                alignItems='center' 
                                borderBottom={activeRoute(`${enviroments.urlBase}/ofertas`) === 'active' ? '2px solid #002FFD' : '1px solid #A4A4A6'}
                            >
                                <IconOferta size='24px' color={activeRoute(`${enviroments.urlBase}/ofertas`) === 'active' ? '#002FFD' : 'black'} />
                                <Text color={activeRoute(`${enviroments.urlBase}/ofertas`) === 'active' ? '#002FFD' : 'black'} my='2' size='lg' className='General'>Ofertas destacadas</Text>
                            </Button>
                        </SplideSlide>
                    </SplideTrack>
                </Splide>
            </Box>
            
            <Box pos='relative'>
                {children}
                <FormularioDown />
                {/* Boton Whatsapp */}
                {
                    viewButtonWp &&
                    <Link href={urlWp} position='fixed' bottom='24' right='2' zIndex='2' aria-label="Ir a whatsapp" isExternal id={`whatsapp_home`}>
                        <motion.button
                            animate={{
                            scale: [1, 1.1, 1],
                            }}
                            transition={{
                                duration: 1.5,
                                ease: "easeInOut",
                                repeat: Infinity,
                                repeatType: "mirror",
                            }}
                        >
                            <Button
                                onClick={(e) => clickActionWp(e)}
                                variant='solid'
                                borderRadius='50%'
                                size='lg'
                                w={['60px', '60px', '50px', '50px', '50px']}
                                h={['60px', '60px', '50px', '50px', '50px']}
                                aria-label='Ir a whatsapp'
                                p='0'
                            >
                                <Image src={Whatsapp} alt='Boton whatsapp' w='100%' h='100%' id={idWp} />
                            </Button>
                        </motion.button>
                    </Link>
                }
            </Box>

            {
                openSlideModal &&
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal 
                        setOpenSlideModal={setOpenSlideModal} 
                        openSlideModal={openSlideModal} 
                        view='navbar' 
                        submitInitial={false} 
                        valuePhoneInitial={''} 
                        plan='Formulario general' 
                        price='' 
                        priceTyc='' 
                        descuento='' 
                        id={id} 
                    />
                </Box>
            }

            <Footer />
        </GoogleReCaptchaProvider>
    )
}

export default Navbar;